import React from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleContainer, Date, Message, DateTimeInput } from '@weezevent/nacre';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import moment from 'moment-timezone';
import Style from './validityPeriod.module.css';

/**
 * Component to add date start and end of discounts
 * @param {object} discountForm: discountForm:  object form
 * @param {func} onDiscounts: onDiscounts : func to set discount form
 * @param {object} discountErrors: discountErrors : object form error
 */

export default function ValidityPeriod({ discountForm, onDiscounts, setDiscountObject, discountErrors, event, showToggleValidityPeriod, onChangeToggleValidityPeriod }) {
    const { t } = useTranslation();
    const locale = i18n.language;
    const now = moment.utc().tz(event.timezone);
    const currentYear = new Date().getFullYear();

    const toggleDates = React.useCallback(
        value => {
            const later = moment
                .utc()
                .tz(event.timezone)
                .add(1, 'hours');
            if (!value) {
                setDiscountObject({ startDate: null, endDate: null }, true);
            } else {
                setDiscountObject({ startDate: now, endDate: later }, true);
            }
            onChangeToggleValidityPeriod(value);
        },
        [event, now, setDiscountObject, onChangeToggleValidityPeriod]
    );

    return (
        <ToggleContainer
            className={Style['validity-toggle']}
            subtitle={t('ticket.discountForm.validity.subtitle')}
            title={t('ticket.discountForm.validity.title')}
            toggle={showToggleValidityPeriod}
            onToggle={toggleDates}
        >
            <div className={Style['validity-container']}>
                <>
                    <div className={Style['validity-field-group']}>
                        <DateTimeInput
                            className={Style['date-time-input']}
                            timeLabel={t('ticket.common.time.start')}
                            dateLabel={t('ticket.common.date.start')}
                            onChange={date => {
                                onDiscounts('startDate', date);
                            }}
                            value={discountForm.startDate}
                            dateProps={{
                                minYear: currentYear,
                                maxYear: currentYear + 15
                            }}
                            locale={locale}
                            timezone={event.timezone}
                            error={t(discountErrors['startDate'])}
                            timeProps={{ placeholder: '00:00' }}
                        />
                    </div>
                    <div className={Style['validity-field-group']}>
                        <DateTimeInput
                            className={Style['date-time-input']}
                            timeLabel={t('ticket.common.time.end')}
                            dateLabel={t('ticket.common.date.end')}
                            onChange={date => {
                                onDiscounts('endDate', date);
                            }}
                            value={discountForm.endDate}
                            dateProps={{
                                minYear: currentYear,
                                maxYear: currentYear + 15
                            }}
                            locale={locale}
                            timezone={event.timezone}
                            error={t(discountErrors['endDate'])}
                            timeProps={{ placeholder: '00:00' }}
                        />
                    </div>
                    {moment(discountForm.endDate) < now && <Message mini title={t('ticket.discountForm.validity.warning')} />}
                </>
            </div>
        </ToggleContainer>
    );
}

ValidityPeriod.propTypes = {
    discountForm: PropTypes.object.isRequired,
    onDiscounts: PropTypes.func.isRequired,
    setDiscountObject: PropTypes.func.isRequired,
    discountErrors: PropTypes.object,
    event: PropTypes.object.isRequired
};
